<template>
    <div class="content-box">
        <Title/>

        <Echarts/>
    </div>
</template>

<script>
export default {
    name: "fmcg",
    data() {
        return {
            params: {
                dataNav: [
                    {
                        name: "交易规模",
                        data: "shares",
                        unit: "亿元"
                    },
                    {
                        name: "渗透率",
                        data: "a101",
                        unit: "％"
                    },
                    {
                        name: "社会消费品零售总额",
                        data: "a104",
                        unit: "亿元"
                    },
                    {
                        name: "融资事件数量",
                        data: "a129",
                        unit: "次"
                    },
                    {
                        name: "融资金额",
                        data: "a130",
                        unit: "亿元"
                    },
                ],
                name: '快消品B2B'
            }
        }
    },
    created() {
        this.$store.dispatch('getIndustry', this.params)
    },
}
</script>

<style scoped>
#app .content-left .el-menu-vertical-demo {
    width: 200px;
}
</style>